<div class="sr-only" role="status">
    {{ show ? ('loadingLabel' | translate) : '' }}
</div>
@if (show) {
    <mat-progress-bar [mode]="mode" [value]="progress"></mat-progress-bar>
}
